import axios from 'axios'

const client = axios.create({
    baseURL: process.env.API_BASE_URL ? process.env.API_BASE_URL.replace(/\/$/, '') : 'api'
})

export function request(endpoint, options) {
    return client.request(endpoint, options).then(response => response.data)
}


// WEBPACK FOOTER //
// ./helper/api.js